import {
  AppNotification,
  NotificationType,
} from 'components/notification/Notification'
import { useGetLoadBuffetDishesFromShQuery } from 'core/api/BuffetDishApi'
import { useCallback, useEffect, useState } from 'react'

export const useLoadDishesFromSh = () => {
  const [isLoadDishesFromSh, setIsLoadDishesFromSh] = useState(false)
  const { data: loadBuffetDishesFromSh } = useGetLoadBuffetDishesFromShQuery(
    null,
    { skip: !isLoadDishesFromSh, refetchOnMountOrArgChange: true },
  )

  useEffect(() => {
    if (loadBuffetDishesFromSh && isLoadDishesFromSh) {
      AppNotification({
        msg: loadBuffetDishesFromSh.detail,
        type: NotificationType.success,
      })
    }
    setIsLoadDishesFromSh(false)
  }, [loadBuffetDishesFromSh, isLoadDishesFromSh])

  return useCallback(() => setIsLoadDishesFromSh(true), [])
}
